const state = {
  stepName: '',
  h5GuideStep: localStorage.h5GuideStep ? parseInt(localStorage.h5GuideStep) : 100,
  h5GuideInactiveMenu: localStorage.h5GuideInactiveMenu ? JSON.parse(localStorage.h5GuideInactiveMenu) : [],
}

const getters = {

}

const mutations = {
  setStepName (state, v) {
    state.stepName = v
  },
  setH5GuideStep (state, v) {
    if ((state.h5GuideStep + 1) === v || v === 99 || v === 0) {
      state.h5GuideStep = v
      localStorage.h5GuideStep = state.h5GuideStep

      if (v !== 99) {
        window.vueApp.$store.getters.gaEvent('Guide', 'view', `step${v}`)
      }
    }
  },
  setH5GuideInactiveMenu (state, v) {
    state.h5GuideInactiveMenu = v
    localStorage.h5GuideInactiveMenu = JSON.stringify(v)
  },
}

const actions = {
  removeInactiveMenu ({ state, commit }, menuName) {
    const newArr = [...state.h5GuideInactiveMenu]
    newArr.splice(newArr.indexOf(menuName), 1)
    commit('setH5GuideInactiveMenu', newArr)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
